/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/meshManage.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-20 22:22:31
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-10 17:59:05
 */

import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';

/**
* @description: 模型加载类，基于模型中心点为底面中心，camera在z轴正向上
* @param {*}
* @return {*}
*/
class MeshManage {
  /**
   * @description:初始化Mesh管理器
   * @param {*} mesh 传入需要的Mesh
   * @return {*}
   */
  constructor(mesh) {
    if (!mesh) {
      return;
    }

    this.mesh = mesh;
    const abstractMesh = this.mesh.getChildMeshes()[0].getHierarchyBoundingVectors();

    const size = abstractMesh.max.subtract(abstractMesh.min);
    this.size = size;
    this.bounding = abstractMesh;
  }

  /**
   * @description: 获取模型中心点
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  getCenterPosition() {
    if (!this.mesh) {
      return {
        x: 0,
        y: 0,
        z: 0,
      };
    }
    const abstractMesh = this.mesh.getHierarchyBoundingVectors();
    console.log(abstractMesh);
    return abstractMesh.max.subtract(abstractMesh.min).scale(0.5);
  }

  /**
   * @description: 获取模型中心点
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  getPosition() {
    if (!this.mesh) {
      return {
        x: 0,
        y: 0,
        z: 0,
      };
    }
    return {
      x: this.mesh.position.x,
      y: this.mesh.position.y,
      z: this.mesh.position.z,
    };
  }

  /**
   * @description: 获取模型尺寸   获取缩放之后的尺寸传入true即可
   * @param {*}
   * @return {*}
   */
  getModelSize(afterScale? = false) {
    if (afterScale) {
      return this.size ? {
        x: this.size.x * this.mesh.scaling.x,
        y: this.size.y * this.mesh.scaling.y,
        z: this.size.z * this.mesh.scaling.z,
      } : {
        x: 0, y: 0, z: 0,
      };
    }
    return this.size || { x: 0, y: 0, z: 0 };
  }

  addRotation(x, y, z) {
    if (x === undefined || y === undefined || z === undefined) {
      return { x: 0, y: 0, z: 0 };
    }
    this.mesh.addRotation(x, y, z);
    return { x, y, z };
  }

  /**
   * @description: 获取mesh的占用最大长方体的xyz，主要针对转角柜
   * @param {*}
   * @return {*}
   */
  getModeMaxMin() {
    if (!this.mesh) {
      return {
        x: 0,
        y: 0,
        z: 0,
      };
    }
    const abstractMesh = this.mesh.getHierarchyBoundingVectors();
    return {
      max: {
        x: Math.max(abstractMesh.max.x, this.mesh.position.x),
        y: Math.max(abstractMesh.max.y, this.mesh.position.y),
        z: Math.max(abstractMesh.max.z, this.mesh.position.z),
      },
      min: {
        x: Math.min(abstractMesh.min.x, this.mesh.position.x),
        y: Math.min(abstractMesh.min.y, this.mesh.position.y),
        z: Math.min(abstractMesh.min.z, this.mesh.position.z),
      },
    };
  }

  /**
   * @description: 设置模型的位置
   * @param {*} position 位置信息
   * @return {*}
   */
  setModelPosition(position) {
    if (position.x === undefined || position.y === undefined || position.z === undefined) {
      return;
    }
    this.mesh.position.x = position.x;
    this.mesh.position.y = position.y;
    this.mesh.position.z = position.z;
  }

  /**
   * @description: 添加子模型，子模型的坐标相对父模型
   * @param {*} mesh 子模型
   * @return {*}
   */
  addChildModel(mesh) {
    if (mesh instanceof AbstractMesh) {
      this.mesh.addChild(mesh);
    }
    if (mesh instanceof MeshManage) {
      if (!mesh.mesh) {
        return;
      }
      this.mesh.addChild(mesh.mesh);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getNumSign(n) {
    if (!Number.isNaN(n)) {
      // 有效数字
      if (n > 0) {
        return 1;
      } if (n < 0) {
        return -1;
      }
      return 0;
    }
    return 0;
  }

  /**
   * @description: 移动柜子到指定位置，建立在相机在x轴负方向，z轴正方向
   * @param {*} vector3 上一个柜子的靠墙的，最下方的，与当前这个柜子接触的点的三维向量
   * @param {*} direction 柜子移动方向向量
   * @return {*}
   */
  moveModelToPosition(vector3, direction, UType = false) {
    if (!this.mesh) {
      return {
        x: 0,
        y: 0,
        z: 0,
      };
    }
    // 柜面与xy面平行
    if (direction.x !== 0 && direction.y !== 0) {
      this.mesh.position.x = this.getModelSize().x * 0.5 * this.getNumSign(direction.x) + vector3.x;
      this.mesh.position.z = this.getModelSize().z * 0.5;
      this.mesh.position.y = vector3.y;
      return {
        x: this.getModelSize().x * 0.5 * this.getNumSign(direction.x) + vector3.x,
        y: vector3.y,
        z: this.getModelSize().z * 0.5,
      };
    }
    // 柜面与yz面平行 ，左边柜，如果向量仅仅是在yz面上，则一定是左边柜
    if (direction.y !== 0 && direction.z !== 0 && direction.x === 0) {
      const position = {};
      const rotation = this.addRotation(0, -Math.PI / 2, 0);

      // 右边柜先将柜子正转90度，然后将左下角的点与原点对齐后，在移动到指定位置
      this.mesh.position.z = this.getModelSize().x * 0.5 + vector3.z;
      this.mesh.position.x = -this.getModelSize().z * 0.5 + vector3.x;
      position.z = this.getModelSize().x * 0.5 + vector3.z;
      position.x = -this.getModelSize().z * 0.5 + vector3.x;
      this.mesh.position.y = vector3.y;
      position.y = vector3.y;
      return { position, rotation };
    }

    // 柜面与yz面平行，左边柜，如果向量仅仅是在xz面上，则一定是左边柜
    if (direction.x !== 0 && direction.z !== 0) {
      let rotation = { x: 0, y: 0, z: 0 };
      if (!UType) {
        rotation = this.addRotation(0, -Math.PI, 0);
      }
      const position = {};
      // 右边柜先将柜子正转90度，然后将左下角的点与原点对齐后，在移动到指定位置
      this.mesh.position.x = -this.getModelSize(UType).x * 0.5 + vector3.x;
      this.mesh.position.z = -this.getModelSize(UType).z * 0.5 + vector3.z;
      position.x = -this.getModelSize(UType).x * 0.5 + vector3.x;
      position.z = -this.getModelSize(UType).z * 0.5 + vector3.z;
      this.mesh.position.y = vector3.y;
      position.y = vector3.y;
      return { position, rotation };
    }
    return vector3;
  }

  // L型柜体在l2l3边上面时  l2上面的柜体摆放是从左到右的（l3->l1） 跟之前的位置摆放不一样所以单独拎出来
  moveL2ModelToPosition(vector3) {
    const position = {};
    const rotation = this.addRotation(0, -Math.PI / 2, 0);

    // 右边柜先将柜子正转90度，然后将左下角的点与原点对齐后，在移动到指定位置
    this.mesh.position.z = vector3.z - this.getModelSize().x * 0.5;
    this.mesh.position.x = -this.getModelSize().z * 0.5 + vector3.x;
    position.z = vector3.z - this.getModelSize().x * 0.5;
    position.x = -this.getModelSize().z * 0.5 + vector3.x;
    this.mesh.position.y = vector3.y;
    position.y = vector3.y;
    return { position, rotation };
  }

  // L型柜体在l2l3边上面时  l2上面的柜体摆放是从左到右的（l3->l1） 跟之前的位置摆放不一样所以单独拎出来
  getL2DatumPoint() {
    const bounds = this.getModelSize();
    return {
      x: this.mesh.position.x + bounds.x / 2,
      y: this.mesh.position.y,
      z: this.mesh.position.z - bounds.z / 2,
    };
  }


  /**
   * @description: 获取下一个要拼装柜子的基准点，建立在相机在x轴负方向，z轴正方向
   * @param {*} direction 基准点与原点的向量方向
   * @return {*}
   */
  getDatumPoint(direction, isUS = false) {
    if (!this.mesh) {
      return {
        x: 0,
        y: 0,
        z: 0,
      };
    }
    // const abstractMesh = this.mesh.getHierarchyBoundingVectors();
    let bounds = this.getModelSize();

    // 柜面与xy面平行
    if (direction.x !== 0 && direction.y !== 0 && direction.z === 0) {
      // 如果是x轴正方向，取柜子靠墙左下的点，
      if (direction.x > 0) {
        return {
          x: this.mesh.position.x + bounds.x / 2,
          y: this.mesh.position.y,
          z: this.mesh.position.z - bounds.z / 2,
        };
      }
      // 反方向就是靠墙右下角
      return {
        x: this.mesh.position.x - bounds.x / 2,
        y: this.mesh.position.y,
        z: this.mesh.position.z - bounds.z / 2,
      };
    }

    // 柜面与yz面平行,左边柜,取靠墙左下角
    if (direction.y !== 0 && direction.z !== 0 && direction.x === 0) {
      return {
        x: this.mesh.position.x + bounds.x / 2,
        y: this.mesh.position.y,
        z: this.mesh.position.z + bounds.z / 2,
      };
    }

    // 柜面与yz面平行,左边柜,取靠墙左下角
    // l3的边    需要判断是否为US柜型 如果是的话减少宽度及长度
    if (direction.x !== 0 && direction.z !== 0) {
      if (isUS) {
        bounds = this.getModelSize();
      }
      return {
        x: this.mesh.position.x - bounds.x / 2,
        y: this.mesh.position.y,
        z: this.mesh.position.z + bounds.z / 2,
      };
    }
    return {
      x: 0,
      y: 0,
      z: 0,
    };
  }

  /**
   * @description: 获取以世界坐标为起点，该模型为终点，其路径上所有模型的总长度
   * @param {*} extraX x上额外的长度（补板等）
   * @param {*} extraZ z上额外的长度（补板等）
   * @return {*}
   */
  getLengthSize(extraX = 0, extraZ = 0) {
    const abstractMesh = this.mesh.getChildMeshes()[0].getHierarchyBoundingVectors();
    const size = abstractMesh.max.subtract(abstractMesh.min);
    return {
      x: Math.abs(this.mesh.position.x - size.x / 2 - extraX),
      z: this.mesh.position.z + size.z / 2 + extraZ,
    };
  }

  /**
   * @description: 获取以世界坐标为起点，该模型为终点，其路径上所有模型的总的中心点
   * @param {*} extraX x上额外的长度（补板等）
   * @param {*} extraZ z上额外的长度（补板等）
   * @return {*}
   */
  getLengthCenter(extraX = 0, extraZ = 0) {
    const abstractMesh = this.mesh.getChildMeshes()[0].getHierarchyBoundingVectors();
    const size = abstractMesh.max.subtract(abstractMesh.min);
    return {
      x: (this.mesh.position.x - size.x / 2 - extraX) / 2,
      z: (this.mesh.position.z + size.z / 2 + extraZ) / 2,
    };
  }

  /**
   * @description: 获取以世界坐标为起点，该模型为终点，其路径上所有模型的总长度和中心点的x
   * @param {*} extra x上额外的长度（补板等）
   * @return {*}
   */
  getLengthXConfigs(extra = 0) {
    const abstractMesh = this.mesh.getChildMeshes()[0].getHierarchyBoundingVectors();
    const size = abstractMesh.max.subtract(abstractMesh.min);
    return {
      length: Math.abs(this.mesh.position.x - size.x / 2 - extra),
      centerPoint: (this.mesh.position.x - size.x / 2 - extra) / 2,
    };
  }

  /**
     * @description: 获取以世界坐标为起点，该模型为终点，其路径上所有模型的总长度和中心点的z
     * @param {*} extra z上额外的长度（补板等）
     * @return {*}
     */
  getLengthZConfigs(extra = 0) {
    const abstractMesh = this.mesh.getChildMeshes()[0].getHierarchyBoundingVectors();
    const size = abstractMesh.max.subtract(abstractMesh.min);
    return {
      length: this.mesh.position.z + size.z / 2 + extra,
      centerPoint: (this.mesh.position.z + size.z / 2 + extra) / 2,
    };
  }
}

export default MeshManage;

